import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from 'i18next-http-backend';
//empty for now


import { pt_PT, en_GB, es_ES } from "./locales";

const resources = {
  ['en-GB']: { translation: en_GB, },
  ['pt-PT']: { translation: pt_PT, },
  ['es-ES']: { translation: es_ES, },
};


i18n
  .use(initReactI18next)
  .use(Backend)
  .init({
    compatibilityJSON: 'v3',// <--- add this line.
    resources,
    //language to use if translations in user language are not available
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    fallbackLng: "en-GB",
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
  });

export default i18n;
